import { CanonStatus, RevisionReason } from '../domain/enums.js';
import { z } from '../zod.js';
import { Fid, IsoTimestamp, RowVersion, Uuid } from './common.js';
import { DocAliasV1, DocBodyV1, DocPropsV1, DocTitle, TypeKey } from './documents.js';
import { queryInt } from './query.js';
/**
 * Revisions and the Trash (1.0b deliverable 18; asked by 1.A, its revision routes in stage 1b and
 * its trash routes in stage 2). A restore brings back the page text only, whatever the revision's
 * reason, a `retype` revision included; a retype is undone by retyping back (DECISIONS entry 38
 * item 2), so `docs.restore` takes no type or field input.
 */
/** `/api/docs/:id/revisions/:revNo`: `revNo` is read from its decimal text. */
export const RevisionParams = z.strictObject({ id: Uuid, revNo: queryInt(1, 2_147_483_647) });
/** One revision in a document's history (`document_revision`), without its body. */
export const RevisionSummaryV1 = z.strictObject({
    revNo: z.number().int().min(1),
    reason: RevisionReason,
    bodyVersion: RowVersion,
    metaVersion: RowVersion,
    title: DocTitle,
    createdAt: IsoTimestamp,
});
/** A whole revision: the stored columns of `document_revision`. */
export const RevisionV1 = z.strictObject({
    ...RevisionSummaryV1.shape,
    documentId: Uuid,
    typeId: Uuid,
    aliases: z.array(DocAliasV1),
    canonStatus: CanonStatus,
    body: DocBodyV1,
    bodySchemaVersion: RowVersion,
    props: DocPropsV1,
});
/** `docs.restore`: the body version the restore is based on (stale answers 409). */
export const RestoreRevisionRequestV1 = z.strictObject({ baseBodyVersion: RowVersion });
/** A document in the Trash. Merged documents stay out of it, so it carries no merged mark. */
export const TrashItemV1 = z.strictObject({
    id: Uuid,
    fid: Fid,
    title: DocTitle,
    typeKey: TypeKey,
    deletedAt: IsoTimestamp,
});
//# sourceMappingURL=revisions.js.map